import TGlobalLoading from './components/global-loading'
import TMessage from './components/message'
import TNotice from './components/notice'
import TButton from './components/button'
import TIcon from './components/icon'
import TInput from './components/input'
import TRadio from './components/radio'
import TCheckbox from './components/checkbox'
import TSwitch from './components/switch'
import TDropdown from './components/dropdown'
import TNumberstepper from './components/numberstepper.vue'
import TPager from './components/pager'
import TTabs from './components/tabs'
import TSelect from './components/select'
import TAutoComplete from './components/auto-complete'
import TEvaluate from './components/evaluate'
// import TSearchFilter from './components/search-filter';
import TTree from './components/tree'
import TTransfer from './components/transfer'
import TChart from './components/charts'
import TDatePicker from './components/date-picker/date-picker.vue'
import TTable from './components/table'
import TModal from './components/modal'
import TPoptip from './components/poptip'
import TTooltip from './components/tooltip'
import TForm from './components/form'
import TProgress from './components/progress'
import TBackTop from './components/back2top'
import TTag from './components/tag'
import TTimeline from './components/timeline'
import TUpload from './components/upload'
import TSlider from './components/slider'
import TLoading from './components/loading'
// import TEditor from './components/editor'
import TSteps from './components/steps'
import TBreadcrumb from './components/breadcrumb'
import TCarousel from './components/carousel'
import TAlert from './components/alert'
import TCard from './components/card'
import TBadge from './components/badge'
import TCalendar from './components/calendar'
import TCascader from './components/cascader'
import TCollapse from './components/collapse'
import TMenu from './components/menu'
import TAvatar from './components/avatar'
import TSlipbox from './components/slipbox'
import drag from './components/drag'
import TVideo from './components/video'
import TGrid from './components/grid'
import TCollapseTransition from './components/transtions/collapse-transition'
import * as constants from './utils/constants'
import locale from './locale'
if (process.env.NODE_ENV === 'production') {
  require('aid-elements/dist/css/aid.min.css')
}
const taurus = {
  TGlobalLoading,
  TMessage,
  TNotice,
  TButton,
  TButtonGroup: TButton.Group,
  TIcon,
  TInput,
  TRadio,
  TRadioGroup: TRadio.Group,
  TCheckbox,
  TCheckboxGroup: TCheckbox.Group,
  TSwitch,
  TNumberstepper,
  TPager,
  TDropdown,
  // TSearchFilter,
  TTree,
  TTransfer,
  TTabs,
  TTabPanel: TTabs.Panel,
  TDropdownItem: TDropdown.Item,
  TDropdownMenu: TDropdown.Menu,
  TSelect,
  TOption: TSelect.Option,
  TOptionGroup: TSelect.OptionGroup,
  TAutoComplete,
  TChart,
  TDatePicker,
  TModal,
  TPoptip,
  TTooltip,
  TTable,
  TForm,
  TFormItem: TForm.Item,
  TProgress,
  TBackTop,
  TTag,
  TTimeline,
  TTimelineItem: TTimeline.Item,
  TUpload,
  // TEditor,
  TSteps,
  TStep: TSteps.Step,
  TBreadcrumb: TBreadcrumb,
  TBreadcrumbItem: TBreadcrumb.Item,
  TSlider,
  TCarousel,
  TCarouselItem: TCarousel.Item,
  TAlert,
  TCard,
  TCardGroup: TCard.Group,
  TBadge,
  TCalendar,
  TCascader,
  TCollapse,
  TPanel: TCollapse.Panel,
  TMenu,
  TMenuGroup: TMenu.Group,
  TMenuItem: TMenu.Item,
  TSubmenu: TMenu.Sub,
  TAvatar,
  TSlipbox,
  TVideo,
  TLoading,
  TCollapseTransition,
  TRow: TGrid.Row,
  TCol: TGrid.Col,
  TEvaluate,
  TTableColumn: TTable.column,
  // TSlipbox: TSlip.Slipbox,
  constants,
  'useLocale': locale.use
}
const directives = [
  drag,
  TTooltip.DTooltip,
  TPoptip.DPoptip
]

const install = function (Vue, opts = {}) {
  locale.use(opts.locale)
  locale.i18n(opts.i18n)
  Object.keys(taurus).forEach((key) => {
    Vue.component(key, taurus[ key ])
  })

  directives.map(directive => {
    Vue.directive(directive.name, directive)
  })

  Vue.prototype.$Loading = TGlobalLoading
  Vue.prototype.$Message = TMessage
  Vue.prototype.$Notice = TNotice
  Vue.prototype.$Modal = TModal
  Vue.prototype.$constants = constants
  Vue.prototype.$FullLoading = TLoading

  // 兼容ie
  NodeList.prototype.forEach = Array.prototype.forEach
}
// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
module.exports = Object.assign(taurus, {install}) // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./src/index.js